module.exports = __webpack_public_path__ + "img/c0db5be.png";